import Header from 'components/headers/bulletins'
import AddIcon from 'assets/images/bulletin/Subtract.svg'
import { useLocation } from 'react-router-dom'
import DeleteIcon from 'assets/images/deletes/delete-black-1.png'
import { useState } from 'react'
import AddBulletinModal from 'components/modals/addbulletin'
import useGetBulletins from '../fundPage/hooks/useGetBulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import useDeleteBulletin from './hooks/useDeleteBulletin'
export default function BulletinPage() {
    const [isOpen, setOpen] = useState<boolean>(false)
    const {
        state,
    }: {
        state: {
            bulletins: Array<IBulletiens>
            isManager: boolean
            moneyPool: string | undefined
        }
    } = useLocation()
    const { bulletins, isLoadingBulletins, refetch } = useGetBulletins(
        state?.moneyPool
    )
    const { mutate } = useDeleteBulletin(refetch)
    return (
        <>
            <div className=" w-full pb-10">
                <Header title="تابلو اعلانات" />
                {state?.isManager && (
                    <div
                        onClick={() => setOpen(true)}
                        className="mx-2 p-4 my-3 flex flex-col items-center justify-center bg-white text-green-1 border-1 border-green-1 border-dashed rounded-xl"
                    >
                        <img src={AddIcon} alt="add" />
                        <p className=" my-2">
                            {' '}
                            اعلان برای اعضای صندوق ثبت کنید
                        </p>
                    </div>
                )}
                <div className=" px-4 my-4">
                    {bulletins ? (
                        bulletins.map((item) => (
                            <div className="bg-main-bg rounded-xl pt-4 ">
                                <div className="  px-4 items-center grid gap-4 grid-cols-3 my-3  w-full">
                                    <p className=" text-center col-span-2">
                                        {item.text}
                                    </p>
                                    <img
                                        src={item.sticker.image}
                                        alt="bulletin"
                                        className=" col-span-1"
                                        onError={(e) => {
                                            e.currentTarget.style.display =
                                                'none'
                                        }}
                                    />
                                </div>
                                {state?.isManager && (
                                    <>
                                        <hr className=" w-full" />
                                        <div className=" text-center py-2 my-1 text-error-3 rounded-md ">
                                            <img
                                                src={DeleteIcon}
                                                alt="delete"
                                                className=" w-10 mx-auto"
                                                onClick={() => {
                                                    mutate({
                                                        moneypoolId:
                                                            state.moneyPool,
                                                        id: item.id,
                                                    })
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        ))
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </div>
            <AddBulletinModal
                show={isOpen}
                onHide={() => setOpen(false)}
                refetch={refetch}
            />
        </>
    )
}
